import { render, staticRenderFns } from "./RegisterFormMoovaSelfServiceForm.vue?vue&type=template&id=082f6d02"
import script from "./RegisterFormMoovaSelfServiceForm.vue?vue&type=script&lang=js"
export * from "./RegisterFormMoovaSelfServiceForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterFormMoovaSelfServiceForm.vue?vue&type=style&index=0&id=082f6d02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports